import React, { useState } from "react";
import { Element, animateScroll as scroll } from "react-scroll";

import { makeFetch } from "../utilities";
import "./Checkname.css";

export default function Checkname() {
  let firstname, lastname;

  const [data, setData] = useState(null);

  function handleCheckname(e) {
    e.preventDefault();

    if (!firstname.value) {
      firstname.focus();
    } else if (!lastname.value) {
      lastname.focus();
    } else {
      makeFetch(
        encodeURI(`/checkname/${lastname.value}/${firstname.value}`),
        data => {
          setData(data);
          scroll.scrollToBottom({
            duration: 800,
            smooth: true
          });
        }
      );
    }
  }

  return (
    <Element id="checkname" name="checkname" className="Checkname">
      <h1>
        <span>Vérifier</span> une signature
      </h1>
      <div className="Checkname-wrapper">
        <form onSubmit={handleCheckname}>
          <fieldset>
            <label htmlFor="firstname">Prénom(s)</label>
            <input
              ref={node => {
                firstname = node;
              }}
              id="firstname"
              type="text"
            />
          </fieldset>
          <fieldset>
            <label htmlFor="lastname">Nom de famille</label>
            <input
              ref={node => {
                lastname = node;
              }}
              id="lastname"
              type="text"
            />
          </fieldset>
          <button type="submit">
            <i className="fas fa-fw fa-search" /> Chercher un signataire
          </button>
        </form>
        <div>
          <p>
            Pour vérifier qu'une signature a bien été prise en compte entrer le
            ou les prénoms du signataire ainsi que son nom de famille et cliquez
            sur le boutton "Chercher un signataire".{" "}
          </p>
          <p>
            Une liste de tous les homonymes correspondants s'affichera alors
            juste en-dessous.
          </p>
          {data && (
            <div className="Checkname-results">
              {data.length > 0 &&
                data.map(item => {
                  return (
                    <li key={item}>
                      1 signataire à <span>{item}</span>
                    </li>
                  );
                })}
              {!data.length && <p>Aucun résultat.</p>}
            </div>
          )}
        </div>
      </div>
    </Element>
  );
}
